
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/home/changelog",
      function () {
        return require("private-next-pages/embed/home/changelog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/home/changelog"])
      });
    }
  